import { Injectable } from '@angular/core';
import { GridInput } from '@it2go/data-grid';
import { microsoftGraphKeysSettingFrag } from './types/microsoft-graph-keys-setting.gql-types';
import { filterFrag } from '../../../services/types/filter.types';
import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import {
    MicrosoftGraphKeysSettingGridObject,
} from '@libs/types/src/inbox/object-type/microsoft-graph-keys-setting.object';
import {
    MicrosoftGraphKeysSettingCreateInput,
} from '@libs/types/src/inbox/input-type/microsoft-graph-keys-setting.create-input';
import { OkObject } from '@it2go/types';
import {
    MicrosoftGraphKeysSettingUpdateInput,
} from '@libs/types/src/inbox/input-type/microsoft-graph-keys-setting.update-input';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import {
    MicrosoftGraphKeysSettingResultObject,
} from '@libs/types/src/inbox/object-type/microsoft-graph-keys-setting-result.object';

@Injectable({ providedIn: 'root' })
export class MicrosoftGraphKeysSettingGqlService extends GqlServiceV2 {

    public getMicrosoftGraphKeysSettings(
        input: GridInput | null = null,
        fragment: string = microsoftGraphKeysSettingFrag,
    ): Promise<MicrosoftGraphKeysSettingGridObject> {
        return this.query(
            `
                query($input: GridInput!) {
                    microsoftGraphKeysSetting {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createMicrosoftGraphKeysSetting(input: MicrosoftGraphKeysSettingCreateInput): Promise<MicrosoftGraphKeysSettingResultObject> {
        return this.mutate(`
            mutation($input: MicrosoftGraphKeysSettingCreateInput!) {
                microsoftGraphKeysSetting {
                    create(input: $input) {
                        ok
                        keysWork
                    }
                }
            }`,
            { input },
        );
    }

    public updateMicrosoftGraphKeysSetting(input: MicrosoftGraphKeysSettingUpdateInput): Promise<MicrosoftGraphKeysSettingResultObject> {
        return this.mutate(`
            mutation($input: MicrosoftGraphKeysSettingUpdateInput!) {
                microsoftGraphKeysSetting {
                    update(input: $input) {
                        ok
                        keysWork
                    }
                }
            }`,
            { input },
        );
    }

    public deleteMicrosoftGraphKeysSetting(input: IdInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: IdInput!) {
                microsoftGraphKeysSetting {
                    delete(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }
}
